import { render, staticRenderFns } from "./CriarAssinatura.vue?vue&type=template&id=1f03fbf5&scoped=true&"
import script from "./CriarAssinatura.vue?vue&type=script&lang=js&"
export * from "./CriarAssinatura.vue?vue&type=script&lang=js&"
import style0 from "./CriarAssinatura.vue?vue&type=style&index=0&id=1f03fbf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f03fbf5",
  null
  
)

export default component.exports